import angular from 'angular';
import { includes } from 'lodash';

module.exports = angular.module('common.filters.in', [])
.filter('in', function() {
  return function(string, array) {
    return includes(array, string);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/in.js
 **/